export class RouterHelperService {
  static appBaseRoute = {
    home: '',
    personProfile: 'person-profile',
    placeProfile: 'place-profile',
    searchResults: 'search-results',
  };

  // Url param string values have to match the names expected by web api
  static urlParam = {
    id: 'id',
    term: 'term',
    location: 'location',
    searchType: 'type',
    defaultCategory: 'defaultCategory',
    latitude: 'latitude',
    longitude: 'longitude',
    serviceCategory: 'serviceCategory',
    serviceCategoryFilter: 'serviceCategoryFilter',
    serviceSelected: 'serviceSelected',
    specialtySelected: 'specialtySelected',
    service: 'service',
    specialty: 'specialty',
    easyClaim: 'easyClaim',
    telehealth: 'telehealth',
    distance: 'distance',
    distanceKms: 'distanceKms',
    affiliatedProvider: 'affiliatedProvider',
    affiliatedProviderConsult: 'affiliatedProviderConsult',
    sort: 'sort',
    myLocationLabel: 'myLocationLabel',
  };

  static routeType = {
    home: 'home',
    personProfile: 'personProfile',
    placeProfile: 'placeProfile',
    searchResults: 'searchResults',
  };

  static getRoute(routeType: string, id: string, name: string, queryParams: {}): RouteUrl {
    // Add slash, can't add it in appBaseRoute becasue it's used in router configuration
    // which doesn't accept a / at the start of the route
    const baseRoute = '/' + RouterHelperService.appBaseRoute[routeType];

    let route = [];

    // Remove special characters from the name and replace spaces with hyphens to make it look tidier in th url.
    // The name is not used anywhere, it's just to make the urls urer and search engine friendly.
    if (name) {
      name = name.replace(/[^a-z0-9 ]+/gi, '').replace(/\s+/g, '-');
      name = encodeURIComponent(name);
    }

    if (
      routeType === RouterHelperService.routeType.personProfile ||
      routeType === RouterHelperService.routeType.placeProfile
    ) {
      route = name ? [baseRoute, id, name] : [baseRoute, id];
    } else {
      route = [baseRoute];
    }

    return queryParams ? new RouteUrl(route, queryParams) : new RouteUrl(route, null);
  }
}

export class RouteUrl {
  constructor(
    public link: any[],
    public query: {},
  ) {}
}
